// ---Third-party imports
import React from 'react'

// ---Framework imports
import {PortalTarget, AutoPortal} from 'uix/components'

// ---Globals
export const WikiModalTarget = () => <PortalTarget as="div" id="WikiModalPortal" />
export const WikiModalPortal = ({children}) => (
  <AutoPortal target="WikiModalPortal">{children}</AutoPortal>
)
